import api from "./axios";

const ORDERS_ENDPOINT = process.env.REACT_APP_ORDERS_ENDPOINT || "/orders";
const CARD_PAYMENT_ENDPOINT =
  process.env.REACT_APP_CARD_PAYMENT_ENDPOINT || "/payments/cards";
const WALLET_CHECKOUT_ENDPOINT =
  process.env.REACT_APP_MP_CHECKOUT_ENDPOINT || "/payments/mercadopago/checkout";
const MODO_CHECKOUT_ENDPOINT =
  process.env.REACT_APP_MODO_CHECKOUT_ENDPOINT || "/payments/modo/checkout";

function unwrap(payload) {
  return payload?.data?.data || payload?.data || payload || {};
}

function toApiError(error, fallback) {
  const message =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    fallback;
  const apiError = new Error(message);
  apiError.code = error?.response?.data?.code || "";
  apiError.status = error?.response?.status || 0;
  apiError.details = error?.response?.data || null;
  return apiError;
}

export async function createOrder(body) {
  try {
    const response = await api.post(ORDERS_ENDPOINT, body);
    return unwrap(response);
  } catch (error) {
    const apiError = toApiError(error, "No se pudo crear el pedido.");
    if (apiError.status === 404 && /^(Not Found|Cannot POST|404)$/i.test(String(apiError.message).trim())) {
      apiError.message = "El servicio de pedidos devolvió 404. Revisá la URL pública de la API y que el backend del comercio tenga montada /api/orders; no se registró esta compra.";
      apiError.code = "CHECKOUT_API_NOT_FOUND";
    }
    throw apiError;
  }
}

export async function payOrderWithCard(body) {
  try {
    const response = await api.post(CARD_PAYMENT_ENDPOINT, body);
    return unwrap(response);
  } catch (error) {
    throw toApiError(error, "Mercado Pago rechazó la operación.");
  }
}

export async function createMercadoPagoCheckout(body) {
  try {
    const response = await api.post(WALLET_CHECKOUT_ENDPOINT, body);
    return unwrap(response);
  } catch (error) {
    throw toApiError(error, "No se pudo abrir Mercado Pago.");
  }
}

export async function createModoCheckout(body) {
  try {
    const response = await api.post(MODO_CHECKOUT_ENDPOINT, body);
    return unwrap(response);
  } catch (error) {
    throw toApiError(error, "No se pudo iniciar el pago con MODO.");
  }
}

export async function getOrderById(orderId) {
  if (!orderId) throw new Error("Falta el identificador del pedido.");

  try {
    const response = await api.get(
      `${ORDERS_ENDPOINT}/${encodeURIComponent(orderId)}`,
      { headers: { "Cache-Control": "no-cache" } }
    );
    return unwrap(response);
  } catch (error) {
    throw toApiError(error, "No se pudo consultar el pedido.");
  }
}
